export type CertGapsPrintFilters = {
  vesselId: string;
  tab?: 'gaps' | 'ok' | 'all';
};

export function certGapsPrintPath(filters: CertGapsPrintFilters): string {
  const qs = new URLSearchParams();
  qs.set('vesselId', filters.vesselId);
  if (filters.tab && filters.tab !== 'gaps') qs.set('tab', filters.tab);
  return `/crew/cert-gaps/print?${qs.toString()}`;
}

export function certGapsListApiUrl(params: URLSearchParams): string | null {
  const vesselId = params.get('vesselId')?.trim();
  if (!vesselId) return null;
  return `/crew/reports/cert-gaps?vesselId=${encodeURIComponent(vesselId)}`;
}

export function certGapsBackPath(params: URLSearchParams): string {
  const vesselId = params.get('vesselId')?.trim();
  if (!vesselId) return '/crew/cert-gaps';
  return `/crew/cert-gaps?vesselId=${encodeURIComponent(vesselId)}`;
}

export function certGapsTabLabel(tab: string | null | undefined): string {
  if (tab === 'ok') return 'OK only';
  if (tab === 'all') return 'All';
  return 'Gaps only';
}
